export default __webpack_public_path__ + "static/media/earthling_1.3168bfa9.png";